'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _airDatepicker = require('air-datepicker');

var _airDatepicker2 = _interopRequireDefault(_airDatepicker);

var _uk = require('air-datepicker/locale/uk');

var _uk2 = _interopRequireDefault(_uk);

var _ru = require('air-datepicker/locale/ru');

var _ru2 = _interopRequireDefault(_ru);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function calendarInit() {
    var isMobile = function isMobile() {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)
        );
    };

    var calendar = {
        initCalendar: function initCalendar(calendarElement) {
            var datePicker = new _airDatepicker2.default('#' + calendarElement.attr('id'), {
                locale: $('html').attr('lang') === 'uk-ua' ? _uk2.default : _ru2.default,
                minDate: new Date(),
                selectedDates: [new Date()],
                dateFormat: 'EEEE, d MMMM, yyyy',
                container: '.js--calendar_container',
                autoClose: true,
                position: function position(_ref) {
                    var $datepicker = _ref.$datepicker,
                        $pointer = _ref.$pointer;

                    // eslint-disable-next-line no-param-reassign
                    $datepicker.style.top = '100%';
                    // eslint-disable-next-line no-param-reassign
                    $datepicker.style.width = '100%';
                    // eslint-disable-next-line no-param-reassign
                    $pointer.style.display = 'none';
                },
                onSelect: function onSelect(_ref2) {
                    var date = _ref2.date;

                    $('#date_desired_travel').val(calendar.formateDate(date));
                }
            });

            $('.js--air-datepicker__input_icon').on('click', function () {
                $('#' + calendarElement.attr('id')).focus();
            });
        },
        formateDate: function formateDate(date) {
            function addLeadingZero(number) {
                return number < 10 ? '0' + number : number;
            }

            return date.getFullYear() + '-' + addLeadingZero(date.getMonth() + 1) + '-' + addLeadingZero(date.getDate());
        }
    };

    $(document).ready(function () {
        var calendarElement = $('.js--date_desired_travel');
        if (calendarElement && calendarElement.length) {
            calendar.initCalendar(calendarElement);
        }
    });
}();